import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/credentials",
	lazy(() => import("./AdminCredentialsPage"))
);
